/* eslint-disable */
import axios from '@/axios.js';

export const advisorSettlementApi = {
  getAdvisorSettlements(payload) {
    return axios.get('admin/advisor-settlements?join=advisor', {
      params: payload,
    });
  },
  getAdvisorSettlement(id) {
    return axios.get(`admin/advisor-settlements/${id}?join=advisor`);
  },
  updateAdvisorSettlement(id, body) {
    return axios.patch(`admin/advisor-settlements/${id}`, body);
  },
};
